import ApplicationSerializer from 'eflex/serializers/application';

export default class JemPartMarriageSerializer extends ApplicationSerializer {
  attrs = {
    task: {
      deserialize: false,
      serialize: false,
    },
  };
}
